import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { Field, reduxForm, SubmissionError } from 'redux-form'

import { addRule } from '../actions/rules'
import { renderInputField, renderSelectField, renderTextAreaField } from '../utils/forms'
import '../styles/FormModals.css'

class RuleAddForm extends React.Component {
       constructor(props) {
              super(props)

              this.submit = this.submit.bind(this)
       }

       submit(props) {

              return this.props.addRule(props)
                     .then(response => {
                            if (response.error) {
                                   throw new SubmissionError({
                                          _error: response.error.message,
                                          ...response.error.fields
                                   })
                            }

                            // If in modal mode, close modal and refresh the list
                            if (this.props.isModal) {
                                   this.props.closeModal();
                                   if (this.props.refreshRules) {
                                          this.props.refreshRules();
                                   }
                            }

                            return response
                     })
       }

       render() {
              const { error, pristine, submitting, handleSubmit, isModal } = this.props

              return (
                     <form className="opform" onSubmit={handleSubmit(this.submit)}>
                            {!isModal && (
                                   <h1>
                                          <span className="text-vw-dark">NUEVA </span>
                                          <span className="text-vw-light">REGLA DE NEGOCIO</span>
                                   </h1>
                            )}

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-pencil-ruler"></i>
                                          Regla
                                   </div>
                                   <div className="opform-grid">
                                          <Field name="Name"
                                                 type="text"
                                                 component={renderInputField}
                                                 label="Nombre de la regla" />
                                          <Field name="Type"
                                                 component={renderSelectField}
                                                 label="Tipo">
                                                 <option value="">Selecciona un tipo...</option>
                                                 <option value="MaxDayDiscount">Descuento por días</option>
                                                 <option value="AlwaysDiscount">Descuento fijo</option>
                                          </Field>
                                   </div>
                            </div>

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-sliders-h"></i>
                                          Configuración
                                   </div>
                                   <div className="opform-grid">
                                          <Field name="MaxDays"
                                                 type="number"
                                                 component={renderInputField}
                                                 label="Dias aplicables" />
                                          <Field name="DiscountPercentage"
                                                 type="number"
                                                 component={renderInputField}
                                                 label="Porcentaje de descuento" />
                                   </div>
                                   <Field name="Locker"
                                          component={renderSelectField}
                                          label="Taquilla">
                                          <option value="">Selecciona un tipo...</option>
                                          <option value="ALL">Todas</option>
                                          <option value="2PAX">2 Equipos de esquí</option>
                                          <option value="3PAX">3 Equipos de esquí</option>
                                          <option value="4PAX">4 Equipos de esquí</option>
                                          <option value="3PAXSS">3 Equipos sin secado</option>
                                          <option value="BNS">Standard</option>
                                          <option value="BNM">Medium</option>
                                   </Field>
                            </div>

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-align-left"></i>
                                          Otros
                                   </div>
                                   <Field name="Condition"
                                          component={renderTextAreaField}
                                          label="Condiciones" />
                            </div>

                            {error && <div className="alert alert-danger">{error}</div>}

                            {!isModal && (
                                   <button className="btn btn-vw opform-submit" type="submit"
                                          disabled={pristine || submitting}>
                                          <i className="fas fa-save mr-2"></i>
                                          Guardar
                                   </button>
                            )}
                            {isModal && (
                                   <div className="opform-footer">
                                          <button
                                                 className="btn btn-secondary"
                                                 type="button"
                                                 onClick={this.props.closeModal}>
                                                 <i className="fas fa-times mr-2"></i>
                                                 Cancelar
                                          </button>
                                          <button
                                                 className="btn btn-vw"
                                                 type="submit"
                                                 disabled={pristine || submitting}>
                                                 <i className="fas fa-save mr-2"></i>
                                                 Guardar
                                          </button>
                                   </div>
                            )}
                     </form>
              )
       }
}

RuleAddForm = reduxForm({
       form: 'RuleAddForm',
       keepDirtyOnReinitialize: true,
       enableReinitialize: true,
       updateUnregisteredFields: true,
       onSubmitSuccess: (result, dispatch, props) => {
              // Only push to route if NOT in modal mode
              if (!props.isModal) {
                     props.push(`/rules`)
              }
       }
})(RuleAddForm)

const mapStateToProps = state => ({
       auth: state.auth,
       role: state.auth.role,
       type: state.auth.type,
       fullname: state.auth.fullname,
})

const mapDispatchToProps = dispatch => ({
       addRule: bindActionCreators(addRule, dispatch),
       push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(RuleAddForm)
